export default __webpack_public_path__ + "static/media/contactsOrange.46b295a2.svg";